import { useTranslation } from '@dukanti/shared';

export interface OrderDetailNotesProps {
  readonly notes: string | null;
}

/**
 * F-022: Customer notes section for the order detail page.
 *
 * Returns null (not rendered) when notes is null or an empty string.
 * When present, renders a blockquote with olive start border and warm
 * stone background.
 */
export function OrderDetailNotes({ notes }: OrderDetailNotesProps): React.JSX.Element | null {
  const { t } = useTranslation();

  if (!notes || notes.trim() === '') {
    return null;
  }

  return (
    <section
      data-testid="order-detail-notes"
      className="border-border bg-card shadow-admin-card rounded-lg border p-6"
    >
      <h2 className="text-muted-foreground mb-3 text-xs font-semibold uppercase tracking-wide">
        {t('admin.orders.detail.notes')}
      </h2>

      <blockquote className="border-admin-lime bg-admin-surface-muted text-foreground rounded-s-md border-s-4 px-4 py-3 text-sm">
        {notes}
      </blockquote>
    </section>
  );
}
